import React, { useCallback } from 'react';
import { Button } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { getIsDAWPlugin } from 'helpers';
import {
    useInteractionSourceContext,
    InteractionSourceContextType,
} from 'contexts/InteractionSourceContext';
import { analytics } from 'utils/analytics';
import { CtaGoal, CtaType } from 'utils/analytics/AnalyticsV2Service.generated';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';

export const useBuyPlanButton = ({
    purchaseLink,
    interactionSource,
}: {
    purchaseLink: string;
    interactionSource: InteractionSourceContextType;
}) => {
    const isDisabled = !purchaseLink;

    const handleOnClick = useCallback(() => {
        getIsDAWPlugin()
            ? window.open(purchaseLink, '_blank')
            : window.location.assign(purchaseLink);

        const destinationUrl = new URL(purchaseLink);

        destinationUrl.searchParams.delete('returnUrl');

        if (interactionSource) {
            analytics.trackCTAClicked({
                ctaType: CtaType.Button,
                ctaGoal: CtaGoal.Checkout,
                interactionSource,
                ctaText: 'Continue to checkout',
                ctaDestination: destinationUrl.toString(),
            });
        }
    }, [interactionSource, purchaseLink]);

    return { isDisabled, handleOnClick };
};

export const _BuyPlanButton = ({
    isDisabled,
    handleOnClick,
}: {
    isDisabled: boolean;
    handleOnClick: () => void;
}) => (
    <Button
        isDisabled={isDisabled}
        variant="secondary"
        onClick={handleOnClick}
        isRounded={true}
    >
        <Trans>Continue to checkout</Trans>
    </Button>
);

const BuyPlanButton = () => {
    const interactionSource = useInteractionSourceContext();
    const { purchaseLink } = useUpsellActionsContext();
    const { isDisabled, handleOnClick } = useBuyPlanButton({
        purchaseLink,
        interactionSource,
    });

    return (
        <_BuyPlanButton isDisabled={isDisabled} handleOnClick={handleOnClick} />
    );
};

export default BuyPlanButton;
